import "core-js/modules/es6.regexp.search";
import _typeof from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/typeof.js";
/* eslint-disable */
/*云客赞app下载栏组件
	 * <component-app-download :page-type="x" :is-promoter="promoter.isPromoter"></component-app-download>
	 page-type:  -1默认   4商详页   其他页面自己加
	 */
import { isWX, isYkzMiniprogram, isYkzAlipayMiniprogram } from '@ykz/ykz-util/platform';
export default {
  name: 'appDownload',
  data: function data() {
    return {
      showAppDownload: true,
      //云客赞app下载栏，默认展示
      nowAppDownLoadStatus: true,
      //手动关闭控制

      weChatId: getUrlParams('weChatId') || window.weChatId,
      isAPP: window.mobileEnv == 'app' ? true : false,
      //是否在云客赞app打开页面
      isMini: isYkzMiniprogram(),
      //是否在微信小程序打开页面
      isAlipayMini: isYkzAlipayMiniprogram(),
      // 是否在支付宝小程序打开
      isWX: isWX() //是否微信
    };
  },

  props: {
    isPromoter: {},
    pageType: {
      type: String,
      default: '-1'
    }
  },
  mounted: function mounted() {
    _typeof(window.componentCenter) == 'object' || (window.componentCenter = {});
    window.componentCenter.appDownload = this;
    console.log('ycf组件初始化：appDownload');
    if (!this.isAPP && !this.isMini && (this.weChatId == 302 || this.weChatId == 421 || this.weChatId == 434 || this.weChatId == 1)) {
      YCF_Plugin.linkedmeInit({
        btnQueue: {
          $elem: $('.component-app-download .btn-download-border'),
          link: location.href
        },
        clickEvent: this.anchorPoint
      });
    }
  },
  methods: {
    closeLayer: function closeLayer() {
      this.showAppDownload = false;
      this.nowAppDownLoadStatus = false;
    },
    //打锚点
    anchorPoint: function anchorPoint() {
      var that = this;
      if (
      //酒景门店页
      location.href.search('/front/platform/goodsDetails') != -1 || location.href.search('/front/platform/storeDetails') != -1) {
        YCF_Plugin.reportUserAnchors({
          event_id: '500124',
          event_content: {
            scenic_id: getUrlParams('scenicId') || getUrlParams('storeId'),
            scenicFrom: getUrlParams('scenicFrom') || ''
          }
        });
      } else if (
      //商详页
      location.href.search('/front/index/entranceTicketDetails') != -1 || location.href.search('/front/index/ticketProductDetails') != -1 || location.href.search('/front/index/showTicketDetails') != -1 || location.href.search('/front/index/specialDetails') != -1 || location.href.search('/front/index/productDetail') != -1) {
        YCF_Plugin.reportUserAnchors({
          event_id: '500096',
          event_content: {
            item_id: getUrlParams('goodId') || ''
          }
        });
      } else {
        //其它页面，未规定要打锚点
      }
    }
  }
};